//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamSpisovePlanyDesigner.ts        </Name>
//    <Description> Seznam spisových plánů                                      </Description>
//    <Author>      THAZMUKA                                                    </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019                            </Copyright>
//    <Created>     2019-10-30                                                  </Created>
//  </FileHeader>

// tento script bude strojně generován podle XML předpisu definujícího SEZNAM

/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * Designer seznamu spisových plánů
     * 
     * @author thazmuka
     * @since 482.1.0.73
     */
    export class SeznamSpisovePlany extends GContentBase<SeznamSpisovePlanyDesigner> {

        /** onContentReady */
        public onContentReady(): void {
            this.init();
        }

        /** init content */
        private init() {

            // inicializace hodnot od rodice
            //SeznamSpisovePlanyDesigner.SeznamBaseInit(this);
        
            this.setTitle();
            this.createGrid();
            this.createMenuBar();
            this.createSidebar();
        }

        /** nastavit titulek dialogu */
        private setTitle() {
                this.title = "jres:32000143" //RC 32000143 : Seznam spisových plánů
        }

        /** vytvořit seznam - definice objektu GRIDu, navázaných událostí atd... */
        private createGrid(): void {

            this.grid = $("<div>").gautofit().appendTo(this.element);

            this.grid.ggrid({
                data: this.view,
                name: "gridSeznam",
                renderMode: "auto",										// auto, all-at-once, paged-sync, paged-async
                columnMode: "full",										// fit (defaultne by melo byt toto), full
                customClass: "ts-grid-seznam-class",
                navigationMode: "row",									// row, cell
                //defaultAction: new GAction({							//obsluzna akce, ktera se spousti dbl clickem nad radkem
                //	name: "doubleClickGridSeznam",
                //	run: (ev, ctx) => {
                //		this.openDetail();
                //	}
                //}),
                searchColumns: this.gridSearchColumns,
                columns: this.gridFormat,
                contextMenu: this.createContextBar(),					// contextové menu
                sort: "dat_od",									        // řazení seznamu 
                selection: (ev, obj) => {
                    this.row = obj.getSelection();
                }
            });

        }

        /**
		 * vytvořit menu
		 */
        private createMenuBar(): void {
            this.menuBar(this.setMenuButtons());
        }

        private createContextBar(): MenuParams[] {
            var bar = this.setMenuButtons();
            return bar;
        }

        private setMenuButtons(): MenuParams[] {
            const bar: MenuParams[] = [];
            return bar;
        }

        /** vytvořit sidebar */
        private createSidebar() {
            this.removeSidebar();
            this.sidebar = $(this.element).gsidebar({
                userSettings: this.userSettings,
                right: {
                    pinned: true,
                    panels: []
                }
            });
        }

        /** odstranit sidebar */
        private removeSidebar() {
            if (this.sidebar !== undefined) {
                this.sidebar.gsidebar("removeAll");
            }
        }

    }
}